import './style/talent-recruitment.scss'

$('.pagenation li').click(function() {
  var index = $(this).index()
  $(this).addClass('active')
  $(this).siblings().removeClass('active')
  $('.table-body ul').eq(index).addClass('pageActive')
  $('.table-body ul').eq(index).siblings().removeClass('pageActive')
})